const FRAME_MS = 16;
const FRAME_BUDGET_MS = 12;
const DATA_BUDGET_RATIO = 0.3;
const GEOMETRY_BUDGET_RATIO = 0.4;

function median(arr: number[]): number {
    if (arr.length === 0) return 0;
    const sorted = [...arr].sort((a, b) => a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 !== 0 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2;
}

class PipelineMetrics {
    private dataRoundTrips: number[] = [];
    private geometrySerializationMs: number[] = [];
    private renderPassMs: number[] = [];

    recordDataRoundTrip(ms: number) {
        this.dataRoundTrips.push(ms);
        if (this.dataRoundTrips.length > 100) this.dataRoundTrips.shift();
    }

    recordGeometrySerialization(itemCount: number, ms: number) {
        this.geometrySerializationMs.push(ms / Math.max(1, itemCount));
        if (this.geometrySerializationMs.length > 50) this.geometrySerializationMs.shift();
    }

    recordRenderPass(_itemCount: number, ms: number) {
        this.renderPassMs.push(ms);
        if (this.renderPassMs.length > 20) this.renderPassMs.shift();
    }

    get dataConcurrencyPerWorker(): number {
        const avg = median(this.dataRoundTrips) || 8;
        return Math.max(1, Math.ceil(FRAME_MS / avg * 1.5));
    }

    get geometryBatchSize(): number {
        const perItem = median(this.geometrySerializationMs) || 0.1;
        const budget = FRAME_BUDGET_MS * GEOMETRY_BUDGET_RATIO;
        return Math.max(50, Math.floor(budget / perItem));
    }

    get expectedRenderMs(): number {
        return median(this.renderPassMs) || 16;
    }
}

export { FRAME_MS, FRAME_BUDGET_MS, DATA_BUDGET_RATIO, GEOMETRY_BUDGET_RATIO };
export const pipelineMetrics = new PipelineMetrics();
